function updateDrawerPosition() {
  const coreHeader = document.querySelector('.site-header-sticky');
  const drawerTarget = document.querySelector('.slide-nav__overflow');

  if (coreHeader && drawerTarget) {
    const headerBottom = coreHeader.getBoundingClientRect().bottom;
    console.log('Header bottom:', headerBottom);

    drawerTarget.style.setProperty('--drawer-position', `${headerBottom}px`);
  }
}

// Run on click
document.querySelector('.js-toggle-slide-nav')?.addEventListener('click', updateDrawerPosition);

// Run on load
window.addEventListener('load', updateDrawerPosition);

// Run on resize
window.addEventListener('resize', updateDrawerPosition);

